export function buttonStyle(color) {
  return {
    border: `1px solid ${color}`,
    backgroundColor: color,
    color: 'white'
  };
}
